import { Input } from "antd";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

export function FilterDropdown(props:any) {
    const { fkey } = props;
    const [value, setValue] = useState('');
    let [query, setQueryParams] = useSearchParams();

    function onSearch(v: string) {
        let params = new URLSearchParams(query.toString());
        let filter = JSON.parse(params.get('filter') || '{}');
        if (v){
            filter[fkey] = {$regex: v, $options: 'i' };
        }
        else {
            delete filter[fkey];
        }
        params.set('filter', JSON.stringify(filter));
        params.set('page', '1');
        setQueryParams(params);
    }

    useEffect(() => {
        let params = new URLSearchParams(query.toString());
        let filter = JSON.parse(params.get('filter') || '{}');
        if (filter[fkey]) {
            setValue(filter[fkey]['$regex']);
        } else {
            setValue('');
        }
    }, [query]);

    return (
        <Input.Search
            value={value}
            placeholder="Search"
            onChange={e => setValue(e.target.value)}
            onSearch={onSearch}
            enterButton
            allowClear
        />
    );
};
